module.exports = __webpack_public_path__ + "img/email.03aea7f4.png";